var styleDataHash = '3e2145a5';  
export const injectCss = (() => {
  var css = `.XuPcc,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.Y2xcL{color:var(--ricos-custom-link-color,var(--ricos-action-color,#116dff));font-family:var(--ricos-custom-link-font-family,unset);font-size:var(--ricos-custom-link-font-size,unset);font-style:var(--ricos-custom-link-font-style,unset);font-weight:var(--ricos-custom-link-font-weight,unset);letter-spacing:var(--ricos-custom-link-letter-spacing,unset);line-height:var(--ricos-custom-link-line-height,unset);min-height:var(--ricos-custom-link-min-height,unset);text-decoration:var(--ricos-custom-link-text-decoration,none)}@supports not (contain:inline-size){@media only screen and (max-width:480px){.Y2xcL{font-size:var(--ricos-custom-link-font-size,unset)}}}@container (width < 480px){.Y2xcL{font-size:var(--ricos-custom-link-font-size,unset)}}.tS0F3:hover{cursor:text}.uFqDN:hover{cursor:pointer}.fqe34{display:flex;margin-right:5px}.fmehm{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff));max-width:270px;overflow:hidden;text-decoration:none;text-overflow:ellipsis;white-space:nowrap}.fmehm:hover{text-decoration:underline}.l-vhu:hover{cursor:pointer}@supports not (contain:inline-size){@media only screen and (max-width:480px){.fmehm{max-width:160px}}}@container (width < 480px){.fmehm{max-width:160px}}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});





